<style scoped lang="less">
.title {
	font-size: 22px;
	background-color: #00bc12;
	border-radius: 5px;
	margin: 10px 0;
	text-align: center;
}

.studyslistrap {
	margin-top: 10px;

	.studyslistitle {
		height: 40px;
		width: 100%;
		background-color: #00bc12;
		display: flex;
		align-items: center;
		color: #fff;
		font-size: 16px;
		padding-left: 10px;
		p {
			margin-right: 10px;
		}
	}

	.studysliscontent {
		padding: 20px;
		background-color: #fff;
		overflow-y: scroll;
		height: 50vh;
		
		
		/deep/ .el-step__line {
			color: #10b981 !important;
			background-color: #10b981 !important;
			border-color: #10b981 !important;
		}
		/deep/ .el-step__icon {
			border-color: #10b981 !important;
		}

		/deep/ .el-step__head {
			height: 160px;
		}
	}

	.steps {
		height: 80px;
		border: 1px solid #10b981;
		margin-bottom: 20px;
		display: flex;
		align-items: center;
		padding-left: 10px;

		.stepscontent {
			margin-left: 10px;
			p {
				color: #000;
			}
			p:first-child {
				font-size: 16px;
			}

			p {
				font-size: 14px;
			}
			p:last-child {
				color: #999;
			}
		}
	}
}

.studysli {
	display: flex;
	background: #fff;
	margin-bottom: 35px;

	.studysleft {
		width: 30%;
		// border: 1px solid;
		margin-right: 20px;

		img {
			width: 100%;
			height: 280px;
		}

		.studyslefttitlectent {
			p {
				margin: 4px 0;
			}
			span {
				font-weight: 700;
			}
		}

		.studyslefttitle {
			margin-top: 10px;
			padding: 20px;
			background-color: #fcefe8;
			border-radius: 10px;
			width: 100%;
			font-size: 16px;
			border-left: 2px solid #00bc12;

			.studysleftdepl {
				text-indent: 20px;
				margin-bottom: 10px;
			}
		}
	}

	.studysright {
		width: 100%;
		.studystitle {
			width: 200px;
			height: 40px;
			border-bottom: 2px solid #00bc12;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #f9f9f9;
		}

		.studysrighttable {
			margin-top: 20px;
			background-color: #f9f9f9;
			.studysrtabletitle {
				display: flex;
				align-items: center;
				border-bottom: 2px solid #ccc;
				padding-left: 10px;
				p {
					width: 33%;
					// text-align: center;
					height: 60px;
					line-height: 60px;
				}
			}

			.studysrtablecontent {
				border-bottom: 1px solid #ccc;
				display: flex;
				align-items: center;
				padding-left: 10px;

				.tablecontentitem {
					display: flex;
					align-items: center;
					padding: 20px 0;
					width: 33%;
					div {
						margin-left: 10px;
						p:first-child {
							color: #000;
							font-size: 16px;
						}
						p:last-child {
							color: #999;
						}
					}
				}

				.tablecontentitem:nth-of-type(2) {
					div {
						margin-left: 10px;
						p:first-child {
							color: #999;
							font-size: 14px;
						}
						p:last-child {
							color: #999;
						}
					}
				}
			}
		}
	}
}

.title {
	color: #fff;
	padding: 10px;
}

.elpagian {
	display: flex;
	align-content: center;
	justify-content: center;
	margin-top: 10px;
	
}
</style>
<template>
	<div>
		<titles titlename="学习地图详情" titlecontent="这里可以看到学习地图详情一些信息" :mbx="paths"></titles>
		<div class="title">行车组织管理专业学习地图</div>
		<div class="studysli">
			<div class="studysleft">
				<img :src="mapobjs.LM_CoverImage" alt="" />
				<div class="studyslefttitle">
					<div class="studysleftdepl">
						{{mapobjs.LM_mapContent}}
					</div>
					<div class="studyslefttitlectent">
						<!-- <p>
							<span>应用班级：</span>
							{{mapobjs.LM_mapContent}}班
						</p> -->
						<p>
							<span>地图创建者：</span>
							{{mapobjs.ui_realName}}
						</p>
						<p>
							<span>创建时间：</span>
							{{mapobjs.LM_createTime}}
						</p>
						<p>
							<span>学习有效期：</span>
							{{mapobjs.LM_indateDate}}
						</p>
					</div>
				</div>
			</div>
			<div class="studysright">
				<div class="studystitle">学习进度</div>
				<div class="studysrighttable">
					<div class="studysrtabletitle">
						<p>学生姓名</p>
						<p>当前学习内容</p>
						<p>学习进度</p>
					</div>
					<div class="studysrtablecontent" v-for="(item,index) in staplist" :key="index">
						<div class="tablecontentitem">
							<el-avatar icon="el-icon-user-solid"></el-avatar>
							<div>
								<p>{{item.ui_realName}}</p>
								<p>{{item.cla_name}}</p>
							</div>
						</div>
						<div class="tablecontentitem">
							<div>
								<p>{{item.SP_planName ?? ''}}</p>
								<p>{{item.PC_planContent ?? ''}}</p>
							</div>
						</div>
						<div class="tablecontentitem" style="padding: 0 !important;margin: 0 !important;">
							<div style="width: 100%;"><el-progress :text-inside="true" text-color="#fff" :stroke-width="24" :percentage="item.Schedule" status="success"></el-progress></div>
						</div>
					</div>
				</div>

				<div class="elpagian">
					<el-pagination
						@current-change="changecurr"
						background
						hide-on-single-page
						layout="prev, pager, next"
						:page-size="tabsnum"
						:total="totalall"
						:current-page="tabindex"
					></el-pagination>
				</div>
			</div>
		</div>

		<div class="studyslistrap">
			<div class="studyslistitle">
				<p style="width: 5px;height: 20px; background-color: #fff;"></p>
				学习记录
			</div>
			
			<div class="studysliscontent" v-infinite-scroll="load">
				<div v-if="staplistall.length == 0" style="width: 100%;">
					<el-empty description="暂无地图学习记录"></el-empty>
				</div>
				<el-steps v-if="staplistall.length > 0" direction="vertical" :active="staplistall.length" finish-status="success">
					<el-step v-for="(item,index) in staplistall" :key="index">
						<div slot="title" class="steps">
							<el-image style="width: 60px; height: 60px" :src="item.ui_photoPath?item.ui_photoPath:'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'"></el-image>
							<div class="stepscontent">
								<p>{{item.td_content}}</p>
								<p>{{item.ui_realName}}</p>
								<p>{{item.td_time}}</p>
							</div>
						</div>
					</el-step>
				</el-steps>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { 
LearnmapDetails,
MapUserList,
MapTrendsLists
 } from '@/request/api/homesview/yunhomes/yunhom.js';

export default {
	data() {
		return {
			// 标题
			paths: [
				{
					path: '/usercenter/myuserpromise',
					name: '学习地图详情'
				}
			],
			totalall:10,
			tabsnum:4,
			tabindex:1,
			staplist:[],
			staplistall:[],
			mapobjs:{},
			mapobjgets:{
				pageIndex:1,
				pageSize:10,
				LM_GUID:''
			},
			alltotles:0
		};
	},
	mounted() {
		this.getmapobjs()
		this.getusersdetails()
		this.getmats()
	},
	methods:{
		load(){
			// console.log('接触底部更多加载')
			if(this.alltotles > this.mapobjgets.pageSize){
				this.mapobjgets.pageIndex+=1
				this.getmats()
			}
			
		},
		getmats(){
			this.mapobjgets.LM_GUID = this.$route.query.LM_GUID
			MapTrendsLists(this.mapobjgets).then(res=>{
				if(res.data.code>0){
					this.staplistall = [...this.staplistall,...res.data.data.list]
					this.alltotles = res.data.data.totalCount
				}
			})
		},
		
		changecurr(val){
			this.tabindex = val
			this.getusersdetails()
		},
		getmapobjs(){
			let obj = {
				LM_GUID:this.$route.query.LM_GUID
			}
			LearnmapDetails(obj).then(res=>{
				// console.log(res.data)
				this.mapobjs = res.data.data
				// this.base64s = res.data.data.LM_CoverImage
			})
		},
		getusersdetails(){
			let obj = {
				LM_GUID:this.$route.query.LM_GUID,
				pageIndex:this.tabindex,
				pageSize:this.tabsnum
			}
			MapUserList(obj).then(res=>{
				// console.log(res,"获取用户详情")
				this.staplist = res.data.data.list
				this.totalall = res.data.data.totalCount
			})
		}
		
	},
	components: {
		titles
	}
};
</script>
